"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var polished_1 = require("polished");

exports.getTheme = function (override) {
  if (override === void 0) {
    override = {};
  }

  var color = __assign({
    base: '#555555',
    primary: '#5283e7',
    primaryBg: '#f1f6ff',
    danger: '#e94141',
    warning: '#ca9727',
    success: '#5bd084',
    successBg: '#e8fff0',
    fadedText: '#aaa'
  }, override.color);

  var input = {
    height: 38,
    fontSize: 14,
    horizontalPadding: 10,
    backgroundColor: '#fff',
    disabledTextColor: '#989898',
    disabledBackground: '#f7f7f7',
    disabledCursor: 'not-allowed',
    borderRadius: 4
  };

  var accordion = __assign({
    contentBackground: '#fff',
    spacing: polished_1.rem(20),
    itemBackground: '#fff',
    activeItemColor: color.primary,
    onHoverTextColor: color.primary
  }, override.accordion);

  var form = __assign({
    labelColor: color.base,
    placeholderColor: '#ccc'
  }, override.form);

  var formGroup = {
    labelGutter: 5,
    bottomMargin: 10
  };

  var menu = __assign({
    spacing: polished_1.rem(20),
    listBackground: '#fff',
    onHoverBackgroundColor: color.primary,
    onHoverTextColor: '#fff',
    activeBackgroundColor: color.primary,
    activeTextColor: color.primary
  }, override.menu);

  var responsiveMenuPrimary = override.responsiveMenuPrimary || color.primary;

  var responsiveMenu = __assign({
    backgroundColor: responsiveMenuPrimary,
    backdropColor: 'rgba(0, 0, 0, 0.25)',
    linkColor: polished_1.lighten(0.9, responsiveMenuPrimary),
    linkColorHighlighted: polished_1.desaturate(0.1, polished_1.lighten(0.5, responsiveMenuPrimary)),
    linkHoverColor: polished_1.darken(0.02, responsiveMenuPrimary),
    siteUrlColor: polished_1.desaturate(0.3, polished_1.lighten(0.2, responsiveMenuPrimary)),
    siteUrlBorder: polished_1.desaturate(0.3, polished_1.lighten(0.2, responsiveMenuPrimary)),
    closeButtonColor: '#fff'
  }, override.responsiveMenu);

  var select = {
    placeholderColor: '#ccc',
    darkerBg: '#f9f9f9',
    padding: 2
  };
  var table = {
    headerBg: '#f9f9f9',
    evenRow: color.base,
    evenRowBg: '#f9f9f9',
    oddRow: color.base,
    oddRowBg: '#ffffff',
    hover: '#f2f2f2',
    activeRow: color.base,
    activeRowBg: color.primaryBg,
    highlightRow: color.base,
    highlightRowBg: color.successBg,
    cellHeight: 42
  };
  var grid = {
    gutterWidth: 10
  };
  var card = {
    contentBg: '#fff',
    secondaryContentBg: '#f9f9f9',
    shadow: "0px " + polished_1.rem(5) + " " + polished_1.rem(20) + " 0 rgba(0, 0, 0, 0.1)",
    secondaryShadow: "0px " + polished_1.rem(1) + " " + polished_1.rem(5) + " 0 rgba(0, 0, 0, 0.1)"
  };
  var tabber = {
    active: color.primary,
    activeLight: color.primaryBg,
    inactive: color.fadedText,
    activeText: color.base,
    borderColor: color.fadedText
  };
  var colorControl = {
    darkColor: color.base,
    lightColor: '#fff'
  };
  var theme = {
    textColor: override.textColor || color.base,
    inactiveColor: override.inactiveColor || '#b5b5b5',
    separatorColor: override.separatorColor || '#eee',
    baseBorderRadius: override.baseBorderRadius || polished_1.rem(2),
    largeBorderRadius: override.largeBorderRadius || polished_1.rem(4),
    fontFamily: override.fontFamily || "'Roboto', sans-serif",
    backgroundColor: override.backgroundColor || '#fff',
    shadow: override.shadow || "0 0 " + polished_1.rem(40) + " 0 rgba(0, 0, 0, 0.2)",
    focusShadow: override.focusShadow || "0 0 " + polished_1.rem(20) + " 0 rgba(82,131,231,0.3)"
  };

  var paginator = __assign({
    backgroundColor: theme.backgroundColor,
    hoverBackgroundColor: polished_1.darken(0.03, theme.backgroundColor),
    activeColor: color.primary,
    disabledColor: color.fadedText,
    borderColor: theme.separatorColor,
    textColor: theme.textColor
  }, override.paginator);

  var checkbox = {
    checkedBackgroundColor: color.primary,
    checkColor: '#fff',
    disabledBackground: '#f7f7f7',
    disabledCheckColor: color.fadedText,
    borderRadius: 2
  };
  return __assign({}, theme, {
    accordion: accordion,
    color: color,
    colorControl: colorControl,
    form: form,
    formGroup: formGroup,
    table: table,
    select: select,
    input: input,
    checkbox: checkbox,
    grid: grid,
    card: card,
    tabber: tabber,
    responsiveMenuPrimary: responsiveMenuPrimary,
    responsiveMenu: responsiveMenu,
    menu: menu,
    paginator: paginator
  });
};

exports.default = exports.getTheme();